module.exports = __webpack_public_path__ + "static/img/erweima.17118d26.png";